// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const buttonContainer = "OnboardingForm__buttonContainer__X6vHR";
export const cardLayout = "OnboardingForm__cardLayout__Lh-zE";
export const controlList = "OnboardingForm__controlList__kbVQe";
export const controlListItem = "OnboardingForm__controlListItem__7I3hS";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const innerHeader = "OnboardingForm__innerHeader__aI55v font-faces__sansMedium__DqLMY font-faces__sans__uCf65";
export const link = "OnboardingForm__link__UqkNZ";
export const listArrayItem = "OnboardingForm__listArrayItem__YkKo6";
export const loginInvitation = "OnboardingForm__loginInvitation__kuVCx font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const medium = "500";
export const onboardingForm = "OnboardingForm__onboardingForm__kXlsJ";
export const onboardingFormWrapper = "OnboardingForm__onboardingFormWrapper__fdxPl";
export const policyLabelLinks = "OnboardingForm__policyLabelLinks__IX0kI";
export const regular = "400";
export const rowButtonListItem = "OnboardingForm__rowButtonListItem__OCRIg OnboardingForm__controlListItem__7I3hS";
export const sans = "'sans'";
export const semibold = "600";
export const serif = "'serif'";
export const spinnerWrapper = "OnboardingForm__spinnerWrapper__D0him";
export const submitListItem = "OnboardingForm__submitListItem__cd2mI";
export const termsInvitation = "OnboardingForm__termsInvitation__dXLlr font-faces__sansRegular__c8KXl font-faces__sans__uCf65";
export const textCenter = "OnboardingForm__textCenter__qBex6";